import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물함")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "gift_box_detail_area is_buy" }
const _hoisted_5 = { class: "gift_info_area" }
const _hoisted_6 = { class: "thum_img_bx" }
const _hoisted_7 = { class: "gift_info_box" }
const _hoisted_8 = { class: "gift_info" }
const _hoisted_9 = { class: "store" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "buy_detail_list" }
const _hoisted_12 = { class: "product_tit_info product_tit_info2" }
const _hoisted_13 = { class: "gift_text_list" }
const _hoisted_14 = { class: "gift_tit" }
const _hoisted_15 = { class: "gift_txt" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("총 ")
const _hoisted_17 = { class: "point_txt" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("개")
const _hoisted_19 = { class: "product_gift_info" }
const _hoisted_20 = { class: "gift_text_list" }
const _hoisted_21 = /*#__PURE__*/_createVNode("dt", { class: "gift_tit" }, "주문번호", -1)
const _hoisted_22 = { class: "gift_txt" }
const _hoisted_23 = { class: "gift_text_list" }
const _hoisted_24 = /*#__PURE__*/_createVNode("dt", { class: "gift_tit" }, "상태", -1)
const _hoisted_25 = { class: "gift_txt txt_state" }
const _hoisted_26 = { class: "detail_list_info" }
const _hoisted_27 = /*#__PURE__*/_createVNode("h3", { class: "detail_sub_tit" }, "주문 정보", -1)
const _hoisted_28 = { class: "detail_list_info last" }
const _hoisted_29 = /*#__PURE__*/_createVNode("h3", { class: "detail_sub_tit" }, "결제 정보", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "product_notice_area" }, [
  /*#__PURE__*/_createVNode("h4", { class: "noti_tit" }, "교환권 구매 취소/환불 안내"),
  /*#__PURE__*/_createVNode("ul", { class: "lst_noti" }, [
    /*#__PURE__*/_createVNode("li", null, "교환권의 구매 및 선물 취소는 교환권 구매일로부터 7일간 가능합니다."),
    /*#__PURE__*/_createVNode("li", null, "주문/선물 취소는 클럽아티제 앱 > 기프트 > 기프트샵 > 선물함 > 구매내역 > 교환권 주문 정보 내 '주문취소'를 선택하거나, 보나비 고객센터에서 신청하실 수 있습니다."),
    /*#__PURE__*/_createVNode("li", null, "교환권 구매 및 선물 취소 시 구매액은 구매 시 이용된 결제수단과 동일한 방법으로 전액 승인 취소 처리됩니다. 만일 구매 시 이용된 결제 전액에 대해 승인 취소가 불가능할 경우 구매자의 선택에 따라 구매자가 지정한 계좌 또는 구매자의 PAYCO 계정에 포인트로 환불될 수 있습니다."),
    /*#__PURE__*/_createVNode("li", null, "프로모션 상품, 사은품, 이벤트 경품 등을 통해 무상으로 받은 교환권은 주문/선물 취소 및 환불 대상이 아닙니다."),
    /*#__PURE__*/_createVNode("li", null, "구매자가 미성년자인 경우 법정대리인이 구매에 동의하지 아니하면 미성년자 본인 또는 법정대리인이 주문을 취소할 수 있습니다."),
    /*#__PURE__*/_createVNode("li", null, "구매/선물 취소 및 환불요청은 미사용된 교환권에 대해서만 가능합니다.")
  ])
], -1)
const _hoisted_31 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_32 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "선물을 취소하시겠습니까?", -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "sub_txt" }, "선물한 사람에게 취소 안내 메시지가 발송되며 교환권은 사용이 불가합니다. 결제 취소가 진행됩니다.", -1)
const _hoisted_34 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, "주문을 취소하시겠습니까?", -1)
const _hoisted_35 = /*#__PURE__*/_createVNode("p", { class: "sub_txt" }, "취소 시 교환권 사용이 불가합니다.", -1)
const _hoisted_36 = {
  key: 0,
  class: "txt"
}
const _hoisted_37 = {
  key: 1,
  class: "txt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_information_component = _resolveComponent("information-component")
  const _component_to_top = _resolveComponent("to-top")
  const _component_popup_component = _resolveComponent("popup-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "wrap",
      class: [{app_view: _ctx.isApp}, "wrap"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_header_component, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("img", {
                src: _ctx.product.productImageUrl,
                alt: "",
                class: "thum_img"
              }, null, 8, ["src"])
            ])
          ]),
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.product.brandName), 1),
              _createVNode("h2", _hoisted_10, _toDisplayString(_ctx.product.productName), 1)
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticketGroupedByName, ([representativeName, tickets]) => {
              return (_openBlock(), _createBlock(_Fragment, { key: representativeName }, [
                _createVNode("dl", _hoisted_12, [
                  _createVNode("a", {
                    class: [{'is_open': _ctx.showReceiverDetail(representativeName)}, "product_link"],
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.toggleReceiverDetail(representativeName)), ["prevent"])
                  }, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("dt", _hoisted_14, "to. ‘" + _toDisplayString(representativeName) + "’", 1),
                      _createVNode("dd", _hoisted_15, [
                        _hoisted_16,
                        _createVNode("span", _hoisted_17, _toDisplayString(tickets.length), 1),
                        _hoisted_18
                      ])
                    ])
                  ], 10, ["onClick"])
                ]),
                _withDirectives(_createVNode("dl", _hoisted_19, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(tickets, (ticket, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "gift_text_list_box"
                    }, [
                      _createVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode("dd", _hoisted_22, _toDisplayString(ticket.ticketId), 1)
                      ]),
                      _createVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode("dd", _hoisted_25, _toDisplayString(_ctx.statusStatement(ticket.ticketStatus)), 1)
                      ])
                    ]))
                  }), 128))
                ], 512), [
                  [_vShow, _ctx.showReceiverDetail(representativeName)]
                ])
              ], 64))
            }), 128))
          ]),
          _createVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_information_component, {
              items: _ctx.orderInformation,
              onClickBtn: this.toggleCancelPopup,
              onClickLink: this.moveToOrderCancellationHistory
            }, null, 8, ["items", "onClickBtn", "onClickLink"])
          ]),
          _createVNode("div", _hoisted_28, [
            _hoisted_29,
            _createVNode(_component_information_component, { items: _ctx.paymentInformation }, null, 8, ["items"])
          ]),
          _hoisted_30
        ])
      ]),
      _createVNode(_component_to_top)
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_31, null, 512), [
      [_vShow, _ctx.showDimemed]
    ]),
    _withDirectives(_createVNode(_component_popup_component, {
      showCancelButton: true,
      onConfirm: _ctx.confirmCancel
    }, {
      default: _withCtx(() => [
        (_ctx.isGiftOrder)
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_32,
              _hoisted_33
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _hoisted_34,
              _hoisted_35
            ], 64))
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showCancelPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, {
      showCancelButton: false,
      onConfirm: _ctx.toggleCancelCompletionPopup
    }, {
      default: _withCtx(() => [
        (_ctx.isGiftOrder)
          ? (_openBlock(), _createBlock("strong", _hoisted_36, "선물 취소(결제 취소)가 완료되었습니다."))
          : (_openBlock(), _createBlock("strong", _hoisted_37, "주문 취소(결제 취소)가 완료되었습니다."))
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showCancelCompletionPopup]
    ])
  ], 64))
}